import React from 'react';
export function Mission() {
  return <section id="qui-sommes-nous" className="py-24 bg-white relative" data-id="element-361">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5" data-id="element-362">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-363">
          <path d="M0,0 L100,0 L100,100 L0,100 Z" fill="url(#grid)" data-id="element-364" />
          <defs data-id="element-365">
            <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-366">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="#000" strokeWidth="0.5" data-id="element-367" />
            </pattern>
          </defs>
        </svg>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-368">
        <div className="text-center mb-20" data-id="element-369">
          <div className="inline-block bg-riskeys-accent-light text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-5" data-id="element-370">
            Qui sommes-nous
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-riskeys-dark mb-6 leading-tight" data-id="element-371">
            Votre partenaire stratégique en{' '}
            <span className="text-riskeys-blue-default" data-id="element-372">
              conseil et audit en assurance
            </span>
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed" data-id="element-373">
            RISKEYS est un cabinet indépendant spécialisé dans les ingénieries
            assurantielles, l'audit des risques et des contrats d'assurance,
            l'optimisation de leurs contrats.
          </p>
        </div>
        <div className="mb-20" data-id="element-374">
          <div className="bg-white rounded-2xl shadow-soft p-10 border border-gray-100" data-id="element-375">
            <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-10" data-id="element-376">
              <div data-id="element-377">
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-378">
                  Nous accompagnons les entreprises et les acteurs publics dans
                  le cadre de la négociation des contrats d'assurance, avec un
                  objectif clair : identifier, quantifier, traiter et transferer
                  leurs risques.
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-379">
                  Nous accompagnons aussi nos clients dans toute démarche de
                  réduction des coûts dans une logique de pérennité, de
                  fiabilité et de solidité des couvertures.
                </p>
                <div className="inline-block bg-riskeys-blue-light/20 text-riskeys-blue-default text-sm font-semibold px-4 py-1.5 rounded-full mb-4 mt-4" data-id="element-380">
                  Notre approche
                </div>
                <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-381">
                  Une vision globale et stratégique de l'assurance
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-382">
                  Chez RISKEYS, nous considérons l'assurance comme un levier
                  stratégique de performance et non comme un simple poste de
                  dépense. Notre approche vise à repositionner la gestion des
                  risques au cœur des décisions de l'entreprise, en intégrant
                  pleinement les enjeux assurantiels dans votre stratégie
                  globale. Nous apportons un regard indépendant, objectif et
                  éclairé, capable de faire émerger des axes d'optimisation à
                  forte valeur ajoutée.
                </p>
              </div>
              <div data-id="element-383">
                <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-384">
                  Une expertise technique au service de la clarté
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-385">
                  Le monde de l'assurance est souvent opaque, complexe et rempli
                  de subtilités contractuelles. Notre rôle est de traduire cette
                  technicité en éléments clairs, exploitables et utiles à la
                  prise de décision. Nous nous appuyons sur une solide maîtrise
                  des produits, du marché, et des acteurs pour proposer des
                  recommandations fondées, pertinentes et alignées sur vos
                  besoins réels.
                </p>
                <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-386">
                  Une approche personnalisée et sur-mesure
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-387">
                  Chaque entreprise a ses spécificités, son activité, sa culture
                  du risque, ses priorités. C'est pourquoi nous évitons les
                  solutions standards. Notre accompagnement est toujours
                  construit autour de vos enjeux propres, avec des diagnostics
                  sur-mesure, une grande écoute, et des propositions concrètes
                  qui prennent en compte votre environnement, vos contraintes et
                  vos ambitions.
                </p>
                <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-388">
                  Un partenariat fondé sur la confiance et la transparence
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-389">
                  Nous plaçons la transparence, l'éthique et la pédagogie au
                  cœur de notre relation avec nos clients. Chez RISKEYS, pas de
                  discours commercial : nous agissons en tant que tiers de
                  confiance, avec un seul objectif : Auditer et vous assister
                  dans le renouvellement de vos contrats.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-390">
          <div className="bg-white rounded-2xl shadow-soft p-8 border border-gray-100 hover:shadow-premium hover:border-riskeys-accent-light transition-all duration-300 group" data-id="element-391">
            <div className="w-16 h-16 bg-riskeys-accent-light rounded-2xl flex items-center justify-center mb-8 group-hover:bg-riskeys-accent-default transition-colors duration-300" data-id="element-392">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-393">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-394" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4 group-hover:text-riskeys-blue-default transition-colors duration-300" data-id="element-395">
              Réduire vos coûts
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-396">
              Nous identifions les économies potentielles dans vos contrats
              actuels et négocions de meilleures conditions financières avec
              votre assureur.
            </p>
            <div className="pt-6 border-t border-gray-100" data-id="element-397">
              <p className="text-riskeys-blue-default font-semibold flex items-center" data-id="element-398">
                <span className="mr-2" data-id="element-399">Jusqu'à 30% d'économies</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-400">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-401" />
                </svg>
              </p>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-soft p-8 border border-gray-100 hover:shadow-premium hover:border-riskeys-blue-light transition-all duration-300 group" data-id="element-402">
            <div className="w-16 h-16 bg-riskeys-blue-light/20 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-riskeys-blue-light/40 transition-colors duration-300" data-id="element-403">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-riskeys-blue-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-404">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-405" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4 group-hover:text-riskeys-blue-default transition-colors duration-300" data-id="element-406">
              Améliorer vos garanties
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-407">
              Nous optimisons la qualité de vos couvertures pour une meilleure
              protection, adaptée à vos besoins spécifiques et à vos risques
              réels.
            </p>
            <div className="pt-6 border-t border-gray-100" data-id="element-408">
              <p className="text-riskeys-blue-default font-semibold flex items-center" data-id="element-409">
                <span className="mr-2" data-id="element-410">Protection optimisée</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-411">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-412" />
                </svg>
              </p>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-soft p-8 border border-gray-100 hover:shadow-premium hover:border-gray-300 transition-all duration-300 group" data-id="element-413">
            <div className="w-16 h-16 bg-riskeys-gray-default rounded-2xl flex items-center justify-center mb-8 group-hover:bg-riskeys-gray-dark transition-colors duration-300" data-id="element-414">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-riskeys-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-415">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-416" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4 group-hover:text-riskeys-blue-default transition-colors duration-300" data-id="element-417">
              Optimiser vos contrats
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-418">
              Nous clarifions et simplifions les termes contractuels pour
              éliminer les clauses inutiles et renforcer celles qui vous
              protègent.
            </p>
            <div className="pt-6 border-t border-gray-100" data-id="element-419">
              <p className="text-riskeys-blue-default font-semibold flex items-center" data-id="element-420">
                <span className="mr-2" data-id="element-421">Clarté contractuelle</span>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-422">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-423" />
                </svg>
              </p>
            </div>
          </div>
        </div>
        <div className="mb-20" data-id="element-424">
          <div className="bg-white rounded-2xl shadow-soft p-10 border border-gray-100" data-id="element-425">
            <div className="text-center mb-12" data-id="element-426">
              <div className="inline-block bg-riskeys-accent-light text-riskeys-dark text-sm font-semibold px-4 py-1.5 rounded-full mb-4" data-id="element-427">
                Nos valeurs
              </div>
              <h3 className="text-2xl font-bold text-riskeys-dark mb-4" data-id="element-428">
                Chez RISKEYS, nos valeurs ne sont pas de simples principes
                affichés
              </h3>
              <p className="max-w-3xl mx-auto text-gray-600" data-id="element-429">
                Elles guident chacune de nos décisions, structurent notre façon
                de travailler, et façonnent la relation que nous construisons
                avec nos clients.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-430">
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:shadow-md transition-all duration-300" data-id="element-431">
                <div className="w-10 h-10 bg-riskeys-accent-default rounded-full flex items-center justify-center mb-4" data-id="element-432">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-433">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-434" />
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-riskeys-dark mb-3" data-id="element-435">
                  Indépendance
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-436">
                  Nous sommes 100 % indépendants des assureurs et des
                  intermédiaires. Cette liberté nous permet d'agir dans votre
                  seul intérêt, sans compromis ni pression commerciale.
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:shadow-md transition-all duration-300" data-id="element-437">
                <div className="w-10 h-10 bg-riskeys-blue-default rounded-full flex items-center justify-center mb-4" data-id="element-438">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-439">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-440" />
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-riskeys-dark mb-3" data-id="element-441">
                  Expertise technique pointue
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-442">
                  La maîtrise technique est au cœur de notre ADN. Nous croyons
                  que seule une compréhension fine des produits, des enjeux
                  juridiques et économiques permet d'optimiser efficacement un
                  programme d'assurance.
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:shadow-md transition-all duration-300" data-id="element-443">
                <div className="w-10 h-10 bg-riskeys-dark rounded-full flex items-center justify-center mb-4" data-id="element-444">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-445">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" data-id="element-446" />
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-riskeys-dark mb-3" data-id="element-447">
                  Transparence
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-448">
                  Nous valorisons une communication claire, directe et sans
                  zones d'ombre. Dans un univers souvent opaque, nous apportons
                  de la lisibilité et favorisons des échanges simples,
                  compréhensibles et fondés sur la confiance mutuelle.
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:shadow-md transition-all duration-300" data-id="element-449">
                <div className="w-10 h-10 bg-riskeys-gray-dark rounded-full flex items-center justify-center mb-4" data-id="element-450">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-451">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" data-id="element-452" />
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-riskeys-dark mb-3" data-id="element-453">
                  Rigueur & exigence
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-454">
                  Chaque détail compte. Notre démarche est construite sur la
                  précision, l'analyse et la recherche constante de solutions
                  innovantes. Nous ne nous contentons pas d'identifier les
                  problèmes, nous les résolvons.
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:shadow-md transition-all duration-300" data-id="element-455">
                <div className="w-10 h-10 bg-riskeys-accent-light rounded-full flex items-center justify-center mb-4" data-id="element-456">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-riskeys-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-457">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-458" />
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-riskeys-dark mb-3" data-id="element-459">
                  Sens du service
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-460">
                  Être disponible, réactif, à l'écoute : c'est ce qui fait la
                  différence dans notre métier. Nous nous impliquons aux côtés
                  de nos clients comme de véritables partenaires, avec une
                  volonté de créer de la valeur à chaque étape.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-20" data-id="element-461">
          <div className="bg-white rounded-2xl shadow-soft p-10 border border-gray-100" data-id="element-462">
            <div className="text-center mb-12" data-id="element-463">
              <div className="inline-block bg-riskeys-blue-light/20 text-riskeys-blue-default text-sm font-semibold px-4 py-1.5 rounded-full mb-4" data-id="element-464">
                Nos partenaires et réseau d'experts
              </div>
              <h3 className="text-2xl font-bold text-riskeys-dark mb-4" data-id="element-465">
                Un réseau solide de partenaires spécialisés
              </h3>
              <p className="max-w-3xl mx-auto text-gray-600" data-id="element-466">
                RISKEYS s'appuie sur un réseau solide de partenaires spécialisés
                pour compléter son expertise interne. Cette collaboration nous
                permet d'offrir une analyse plus complète et des solutions
                parfaitement adaptées à chaque situation.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-467">
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:bg-riskeys-blue-light/10 transition-all duration-300" data-id="element-468">
                <h4 className="font-bold text-riskeys-blue-default mb-3" data-id="element-469">
                  Actuaires indépendants
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-470">
                  Expertise technique pour l'analyse des risques et
                  l'optimisation des programmes d'assurance
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:bg-riskeys-blue-light/10 transition-all duration-300" data-id="element-471">
                <h4 className="font-bold text-riskeys-blue-default mb-3" data-id="element-472">
                  Experts sinistres
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-473">
                  Conseillers spécialisés en droit des assurances et
                  responsabilité civile
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:bg-riskeys-blue-light/10 transition-all duration-300" data-id="element-474">
                <h4 className="font-bold text-riskeys-blue-default mb-3" data-id="element-475">
                  Préventeurs
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-476">
                  Spécialistes de la gestion préventive des risques
                  opérationnels et industriels
                </p>
              </div>
              <div className="bg-riskeys-gray-light rounded-xl p-6 hover:bg-riskeys-blue-light/10 transition-all duration-300" data-id="element-477">
                <h4 className="font-bold text-riskeys-blue-default mb-3" data-id="element-478">
                  Spécialistes sectoriels
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-479">
                  Experts dédiés aux problématiques spécifiques de votre
                  industrie
                </p>
              </div>
            </div>
            <div className="mt-8 text-center" data-id="element-480">
              <p className="text-gray-600 italic" data-id="element-481">
                Notre indépendance totale vis-à-vis des assureurs et des
                courtiers garantit que ces partenariats sont exclusivement
                orientés vers la défense des intérêts de nos clients, avec un
                objectif d'excellence technique et d'optimisation durable.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-24" data-id="element-482">
          <div className="bg-white rounded-2xl shadow-soft p-10 border border-gray-100" data-id="element-483">
            <div className="grid md:grid-cols-5 gap-8 items-center" data-id="element-484">
              <div className="md:col-span-2" data-id="element-485">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80" alt="Hosni Mounir - Président de Riskeys" className="w-full h-auto rounded-2xl object-cover shadow-md" data-id="element-486" />
              </div>
              <div className="md:col-span-3" data-id="element-487">
                <div className="inline-block bg-riskeys-blue-light/20 text-riskeys-blue-default text-sm font-semibold px-4 py-1.5 rounded-full mb-4" data-id="element-488">
                  Mot du Président
                </div>
                <h3 className="text-2xl font-bold text-riskeys-dark mb-4" data-id="element-489">
                  Hosni Mounir
                </h3>
                <p className="text-gray-600 mb-5 italic" data-id="element-490">
                  "Chez Riskeys, nous concevons l'assurance comme un levier de
                  performance pour votre entreprise. Notre indépendance totale
                  nous permet d'agir comme un véritable tiers de confiance, avec
                  pour seule motivation la défense de vos intérêts."
                </p>
                <p className="text-gray-600 mb-8" data-id="element-491">
                  Fort de plus de 10 ans d'expertise dans le conseil et l'audit
                  en assurance, notre cabinet vous accompagne dans
                  l'identification, la quantification et le transfert optimal de
                  vos risques, tout en réduisant significativement vos coûts de
                  couverture.
                </p>
                <div className="flex items-center text-sm text-gray-500" data-id="element-492">
                  <span className="font-semibold mr-2" data-id="element-493">Hosni Mounir</span>
                  <span className="text-gray-400" data-id="element-494">|</span>
                  <span className="ml-2" data-id="element-495">Président fondateur de Riskeys</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-24 bg-gradient-to-br from-riskeys-dark to-riskeys-blue-dark rounded-2xl p-10 text-white shadow-premium overflow-hidden relative" data-id="element-496">
          <div className="absolute top-0 left-0 w-full h-full bg-riskeys-blue-default opacity-10" data-id="element-497">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-498">
              <pattern id="pattern-circles" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse" data-id="element-499">
                <circle id="pattern-circle" cx="10" cy="10" r="1.5" fill="#fff" data-id="element-500"></circle>
              </pattern>
              <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-circles)" data-id="element-501"></rect>
            </svg>
          </div>
          <div className="md:flex md:items-center md:justify-between relative z-10" data-id="element-502">
            <div className="mb-8 md:mb-0 md:w-2/3" data-id="element-503">
              <div className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-5" data-id="element-504">
                Notre différence
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-505">
                Nous ne sommes pas un courtier en assurance
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-506">
                Nous sommes un cabinet indépendant de conseil et d'audit en
                assurance qui optimise vos contrats existants. Notre
                rémunération est uniquement basée sur les économies réalisées -
                pas d'économies, pas d'honoraires.
              </p>
            </div>
            <div className="md:w-1/3 text-center" data-id="element-507">
              <a href="#contact" className="inline-block bg-white text-riskeys-blue-default font-bold py-3.5 px-8 rounded-full hover:bg-riskeys-accent-default hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-508">
                Découvrir notre approche
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}